import { render, staticRenderFns } from "./ContractorDisplayBox.vue?vue&type=template&id=620455af&"
import script from "./ContractorDisplayBox.vue?vue&type=script&lang=js&"
export * from "./ContractorDisplayBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports